import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import CourtsFiltersContainer from '../containers/CourtsFiltersContainer';
import HeaderContainerTemplate from '../containers/templates/HeaderContainerTemplate';
import { courtsFiltersModes } from '../utils/constants';
import { initCourtFilters } from '../actions/filterActions';
import Button from '../components/Button';
import i18n from '../utils/i18n';
import routeConstants from '../utils/routeConstants';

import './styles/CourtsFiltersScreen.scss';

class CourtFilters extends React.Component {
  constructor(props) {
    super(props);
    this.routeToCourtsScreen = this.routeToCourtsScreen.bind(this);
  }

  componentDidMount() {
    this.props.initCourtFilters();
  }

  routeToCourtsScreen() {
    this.props.dispatch(push(routeConstants.COURTS_ROUTE));
  }

  render() {
    return (
      <HeaderContainerTemplate>
        <div className="courts-filters-screen">
          <div className="header2">
            {i18n.t('courtsFiltersScreen.FILTER_COURTS')}
          </div>
          <CourtsFiltersContainer
            courtsFiltersMode={ courtsFiltersModes.FULL }
            updateOnSelect={ false }
          />
          <Button
            text={ i18n.t('courtsFiltersScreen.FILTER') }
            onClick={ this.routeToCourtsScreen }
            buttonClass="filters-save-button"
          />
        </div>
      </HeaderContainerTemplate>
    );
  }
}

CourtFilters.propTypes = {
  initCourtFilters: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  initCourtFilters: () => dispatch(initCourtFilters())
});

export default connect(null, mapDispatchToProps)(CourtFilters);



// WEBPACK FOOTER //
// ./src/scenes/CourtsFilters.js